import React, { useEffect, useState } from 'react';

import Image from 'next/image';

import HubspotForm from '../../common/HubspotForm';
import Styles from './TwoColumnForm.module.scss';

const TwoColumnForm = ({
  formId,
  content,
}: {
  formId: string;
  content: { title: string; list: string[] };
}) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true); // Set to true after hydration
  }, []);

  if (!isClient) return null;

  return (
    <div className={Styles.wrapper}>
      <div className={Styles.column}>
        <div>
          {content?.title && <h2 className={Styles.header}>{content?.title}</h2>}
          <ul className={Styles.list}>
            {content?.list?.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
        <Image
          className={Styles.image}
          src="/images/miscellaneous/forms.png"
          alt="form-image"
          width="270"
          height={0}
          sizes="270px"
        />
      </div>
      <div className={Styles.column}>
        <div className={Styles.card}>
          <HubspotForm formId={formId} />
        </div>
      </div>
    </div>
  );
};

export default TwoColumnForm;
